import React, { Component } from "react";
import View from "./view";
import { getSavedForms, removeSavedForm } from "../../backend/storage";
import { delay } from "../../backend";
import Overlay from "../../components/overlay";
import "./index.css";

class SavedForms extends Component {
  constructor(props) {
    super(props);
    this.state = {
      savedForms: []
    };

    this._resubmit = this._resubmit.bind(this);
  }

  async componentDidMount() {
    this.setState({ savedForms: await getSavedForms() });
  }

  render() {
    return View.call(this);
  }

  _renderSavedForm(
    { title, label, url, options, loading, uploaded, date },
    key
  ) {
    return (
      <div
        key={key}
        className="saved-form"
        onClick={this._resubmit({ title, url, options })}
      >
        {loading && <Overlay style={{ width: "100%", height: "100%" }} />}
        <div className="header">
          <div className="label">{label || "No label"}</div>
          <div className="description">{title || "No title"}</div>
        </div>
      </div>
    );
  }

  _resubmit({ title, label, url, options }) {
    const { savedForms } = this.state;
    return async () => {
      this.setState({
        savedForms: savedForms.map(form => {
          if (form.title === title) {
            return { ...form, loading: true };
          } else {
            return form;
          }
        })
      });
      try {
        await delay(1000);
        await fetch(url, options);
        await removeSavedForm(title);
        this.setState({ savedForms: await getSavedForms() });
      } catch (error) {
        this.setState({
          savedForms: savedForms.map(form => {
            if (form.title === title) {
              return { ...form, loading: false };
            } else {
              return form;
            }
          })
        });
      }
    };
  }
}

export default SavedForms;



// WEBPACK FOOTER //
// ./src/screens/saved-forms/index.js